import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionPresenterComponent } from './question-presenter/question-presenter.component';
import { QuestionMultipleChoiceComponent } from './question-multiple-choice/question-multiple-choice.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { LoaderGlobeAnimationDetailComponent } from '../../loaders/loader-globe-animation-detail/loader-globe-animation-detail.component';
import { AlertModule } from 'ngx-bootstrap/alert';
import { RouterModule } from '@angular/router';
import { QuestionModeHomeTypeOneComponent } from './question-mode-home-type-one/question-mode-home-type-one.component';
import { ProgressIndicatorCardSimpleModule } from '../../tracking/progress/progress-indicator-card-simple/progress-indicator-card-simple.module';
import { QuestionLickertComponent } from './question-lickert/question-lickert.component';
import { BellCurveModule, IconArrayModule, ImageUrlPipe, ImageForRolePipe } from '@frontend/shared';
import { SurveyContextModule } from '../survey-context';
import { SurveyRatersModule } from '../survey-raters/survey-raters.module';
import { QuestionCreditsComponent } from './question-credits/question-credits.component';



@NgModule({
  declarations: [
    QuestionPresenterComponent,
    QuestionMultipleChoiceComponent,
    QuestionLickertComponent,
    QuestionModeHomeTypeOneComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslocoModule,
    LoaderGlobeAnimationDetailComponent,
    AlertModule,
    RouterModule,
    ProgressIndicatorCardSimpleModule,
    BellCurveModule,
    IconArrayModule,
    SurveyContextModule,
    SurveyRatersModule,
    ImageUrlPipe,
    ImageForRolePipe,
    QuestionCreditsComponent,
  ],
  exports: [
    QuestionPresenterComponent,
    QuestionMultipleChoiceComponent,
    QuestionLickertComponent,
    QuestionModeHomeTypeOneComponent,
  ]
})
export class SurveyQuestionsModule { }
